module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAtCAMAAAATDSIbAAAAS1BMVEUAAADU5//U5//U5//X6f/U5//V5//T6P/U5//T6P/U5//W6P/V6f/U6f/U5v/T6f/V5//T5v/U5//U5//T5//U6P/U5//S6P/U5/9r5M8XAAAAGHRSTlMA4umVIoOFIdYriywnGm4X2nh0v8FYQS06i+LiAAAA40lEQVQ4y33SWa7CMBBE0c5EAmRgeEPtf6UEGVw2V+L+WTqyZHdHau2CdWt5WqWORForsiOSAt2khECkm4mRSYGukhGIdH0TIxOjgypEokMQkRCR7A0qm0AqxIYIIBIgEiASIBIgEnaqyInACAToC9nmjEzmrSJTe4w0Ow/g2E5bSaSMTCSjZScZDRoy2dFiUqC/TIyWi/RC50iZSJclEaDzkxjdJaAncffomxqBNH18ov8gAfoFIRIIEUlqBAJJiGQ0MAIBIiECYXMr16bFJGp8iwkQCOsb/8s3REIEwsYfPPoB359FlNaY0hEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/xicon.png
// module id = P67q
// module chunks = 1